import Typical from "react-typical"
import React from "react"
import "./Profile.css"

export default function Profile() {
    return (
        <>

            <head>
                <meta charSet="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <title>Md Nazmul Hossain - Frontend Developer Portfolio | React.js Specialist</title>
                <meta name="description" content="Explore the portfolio of Md Nazmul Hossain, a skilled frontend developer specializing in React.js with 1.4 years of experience. Contact Md Nazmul Hossain for frontend development solutions." />
                {/* Add more meta tags as needed */}
            </head>
            <div className="profile-container">

                <div className="profile-parent">
                    <div className="profile-details">
                        <div className="colz">
                            <div className="colz-icon">
                                <a href="https://www.facebook.com/nazmulhossain.me" target="_blank" rel="noreferrer">
                                    <i className="fa fa-facebook-square"></i>
                                </a>
                                <a href="https://www.instagram.com/hossionmdnazmul/" target="_blank" rel="noreferrer">
                                    <i className="fa fa-instagram"></i>
                                </a>
                                <a href="https://www.linkedin.com/in/nazmul-hossain-rdo/" target="_blank" rel="noreferrer">
                                    <i className="fa fa-linkedin"></i>
                                </a>
                                <a href="https://twitter.com/nazmulrdo" target="_blank" rel="noreferrer">
                                    <i className="fa fa-twitter"></i>
                                </a>
                            </div>
                        </div>

                        <div className="profile-details-name">
                            <span className="primary-text">
                                hello, I'M
                            </span>
                        </div>

                        <div className="profile-details-role">
                            <span>
                                {" "}
                                <h1>
                                    <Typical
                                        loop={Infinity}
                                        steps={[
                                            "Md Nazmul Hossain ", 1000,
                                            "Full Stack Developer", 1000,
                                            "MERN Stack Dev.", 1000,
                                            " Frontend Developer", 1000,
                                            "Node js Developer ", 1000
                                        ]}
                                    />
                                </h1>
                                <span className="profile-role-tagline">
                                    My goal is to create engaging and accessible web applications that exceed client expectations. Let's collaborate and bring your ideas to life!
                                </span>
                            </span>
                        </div>
                        <div className="profile-optins">
                            <a href="https://www.linkedin.com/in/nazmul-hossain-rdo">
                                <button className="btn primary-btn">
                                    Hire Me
                                </button>
                            </a>
                            <a href="Nazmul_CV_frontend_developer.pdf" download='frontend_developer_Nazmul.pdf'>
                                <button className="btn highlighted-btn">Get Resume</button>
                            </a>
                        </div>
                    </div>
                    <div className="profile-picture">
                        <div className="profile-picture-background">
                        </div>
                    </div>
                </div>
            </div></>
    );
}
